// Lab page colours: the PI picks one; everything else is derived so text stays readable.
export const DEFAULT_LAB_COLOR = '#5b5fc7';
export const LAB_COLORS = ['#5b5fc7', '#1e3a5f', '#0f766e', '#15803d', '#b45309', '#b91c1c', '#9d174d', '#6d28d9', '#334155'];

export const labColor = (lab) => (/^#[0-9a-f]{6}$/i.test(lab?.background_color || '') ? lab.background_color : DEFAULT_LAB_COLOR);

// #rrggbb + alpha (0–1) -> #rrggbbaa
export const tint = (hex, alpha) => `${hex}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`;

export const coverBackground = (lab) => {
  const c = labColor(lab);
  return lab?.cover_url
    ? `linear-gradient(180deg, ${tint('#000000', 0.05)} 0%, ${tint('#000000', 0.55)} 100%), url(${lab.cover_url}) center / cover no-repeat`
    : `linear-gradient(135deg, ${c} 0%, ${tint(c, 0.75)} 60%, ${tint(c, 0.55)} 100%)`;
};

// Avatar without a photo: a soft version of the lab colour, initials in the full colour
export const labAvatarSx = (lab) => {
  const c = labColor(lab);
  return { bgcolor: tint(c, 0.22), color: c, fontWeight: 600 };
};
